<template>
  <v-container>
    <v-card-text>
      <v-sheet outlined class="pa-1 pa-6">
        <v-row>
          <v-col cols="6" md="4">
            <label>شماره درخواست: </label>
            <strong>
              {{ tradeRequestItem.tradeNumber }}
            </strong>
          </v-col>
          <v-col cols="6" md="4">
            <label>موضوع درخواست: </label>
            <strong>
              {{ tradeRequestDisplayName(tradeRequestItem.request) }}</strong
            >
          </v-col>
          <v-col cols="6" md="4">
            <label>نوع درخواست: </label>
            <strong>
              {{ tradeCategoryDisplayName(tradeRequestItem.category) }}</strong
            >
          </v-col>
          <v-col cols="6" md="4">
            <label> مهلت شرکت در استعلام: </label>
            <strong
              >{{ tradeRequestItem.bidExpirationTimeInDays }} روز ({{
                tradeRequestItem.bidExpirationTimeInDaysFromNow != 0
                  ? tradeRequestItem.bidExpirationTimeInDaysFromNow +
                    'روز باقی مانده'
                  : 'منقضی شده'
              }})</strong
            >
          </v-col>
          <v-col
            cols="6"
            md="4"
            v-if="tradeRequestItem.request != 'ContractorRecognition'"
          >
            <label> نام کسب و کار: </label>
            <strong>{{ tradeRequestItem.merchantName }}</strong>
          </v-col>
          <v-col cols="12" v-else>
            <label> تشریح پروژه:</label>
            <strong>{{ tradeRequestItem.content }} </strong>
          </v-col>
          <v-col
            cols="6"
            md="4"
            v-if="tradeRequestItem.request != 'ContractorRecognition'"
          >
            <label> روش پرداخت:</label>
            <strong
              >{{ paymentMethodDisplayName(tradeRequestItem.paymentMethod) }}
            </strong>
          </v-col>
          <v-col cols="12" v-else>
            <label> عنوان طرح:</label>
            <strong>{{ tradeRequestItem.orderDescription }} </strong>
          </v-col>
          <v-col
            cols="6"
            md="4"
            v-if="tradeRequestItem.request != 'ContractorRecognition'"
          >
            <label> نام و شماره موبایل مسئول:</label>
            <strong
              >{{ tradeRequestItem.ownerName }} -
              {{ tradeRequestItem.ownerPhoneNumber }}</strong
            >
          </v-col>
        </v-row>
      </v-sheet>
      <v-sheet
        outlined
        class="pa-1 pa-6 mt-5"
        v-if="tradeRequestItem.request != 'ContractorRecognition'"
      >
        <v-row>
          مشاهده اقلام:
          <v-col cols="12">
            <v-data-table
              :items="tableItems"
              :headers="
                tradeRequestItem.request != 'ContractorRecognition'
                  ? itemsTableFields
                  : contracterRecognitionHeader
              "
              disable-pagination
              hide-default-footer
            >
              <template v-slot:[`item.responseDocumentCount`]="{ item }">
                {{
                  item && item.responseDocuments
                    ? item.responseDocuments.length
                    : ''
                }}
              </template>
              <template v-slot:[`item.documentCount`]="{ item }">
                {{ item && item.documents ? item.documents.length : '' }}
              </template>
              <template v-slot:[`item.deliveryType`]="{ item }">
                {{ DeliveryDurationDisplayName(item.deliveryType) }}
              </template>
              <template v-slot:[`item.deliveryLocation`]="{ item }">
                {{ DeliveryLocationDisplayName(item.deliveryLocation) }}
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  icon
                  title="مشاهده"
                  color="primary"
                  @click="displayResponsesPerItem(item)"
                >
                  <v-icon> mdi-eye </v-icon>
                </v-btn>
              </template>
            </v-data-table>

            <!-- <v-dialog width="900" ></v-dialog> -->
          </v-col>
        </v-row>
      </v-sheet>
    </v-card-text>
    <v-card-actions v-if="tradeRequestItem.request == 'ContractorRecognition'">
      <v-spacer />
      <v-btn
        small
        color="primary"
        @click="displayResponsesPerItem(tableItems[0])"
      >
        مشاهده
      </v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const enumsRepository = () => RepoFactory.get('enums');
const tradeResponseRepository = () => RepoFactory.get('tradeResponse');
const tradeRequestResponseRepository = () =>
  RepoFactory.get('tradeRequestResponse');
const tradeRequestRepository = () => RepoFactory.get('tradeRequests');
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
export default {
  mixins: [asyncLoadMixin, reusableMethodsMixin],
  created() {
    this.id = this.$route.params.id;
    this.getDataById();
    this.tradeCategories();
    this.tradeRequestType();
    this.tradePaymentMethod();
    this.DeliveryLocationType();
    this.DeliveryDurationType();
  },
  data() {
    return {
      pageNumber: 1,
      itemsPerPage: 20,
      id: null,
      tradePaymentMethodList: [],
      deliveryDurationTypeList: [],
      rawMaterialSupplyTypesList: [],
      deliveryLocationList: [],
      tradeCategoriesList: [],
      tradeRequestTypeList: [],
      tradeRequestItem: [],
      tableItems: [],
      contracterRecognitionHeader: [
        {
          value: 'documentCount',
          text: 'تعداد مدارک پیوست ',
          sortable: true,
        },
        {
          value: 'responseDocumentCount',
          text: 'تعداد مدارک پاسخ',
          sortable: true,
        },
        {
          value: 'actions',
          text: 'اقدام',
          sortable: true,
        },
      ],
      itemsTableFields: [
        {
          value: 'title',
          text: 'موضوع ',
          sortable: true,
        },

        {
          value: 'quantity',
          text: 'تعداد کالا',
          sortable: true,
        },
        {
          value: 'deliveryType',
          text: 'روند تحویل',
          sortable: true,
        },

        {
          value: 'deliveryLocation',
          text: 'محل تحویل',
          sortable: true,
        },
        {
          value: 'measurementUnitTitle',
          text: 'واحد اندازه گیری',
          sortable: true,
        },
        {
          value: 'actions',
          text: 'اقدام',
          sortable: true,
        },
      ],
    };
  },
  computed: {
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
    tradeBaseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    fileBaseUrl() {
      return this.$store.getters.fileBaseUrl;
    },
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    accountingBaseUrl() {
      return this.$store.getters.accountingServiceBaseUrl;
    },
  },
  methods: {
    tradeCategoryDisplayName(title) {
      if (this.tradeCategoriesList.length) {
        let result = this.tradeCategoriesList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeRequestDisplayName(title) {
      if (this.tradeRequestTypeList.length) {
        let result = this.tradeRequestTypeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    paymentMethodDisplayName(title) {
      if (this.tradePaymentMethodList.length) {
        let result = this.tradePaymentMethodList.find(
          (el) => el.title == title
        );
        if (result) return result.displayName;
      }
    },
    DeliveryDurationDisplayName(title) {
      if (this.deliveryDurationTypeList.length) {
        let result = this.deliveryDurationTypeList.find(
          (el) => el.title == title
        );
        if (result) return result.displayName;
      }
    },
    DeliveryLocationDisplayName(title) {
      if (this.deliveryLocationList.length) {
        let result = this.deliveryLocationList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeCategories() {
      this.tradeCategoriesList = this.getEnumByTitle('CategoryTypeItems');
    },
    DeliveryDurationType() {
      this.deliveryDurationTypeList = this.getEnumByTitle(
        'DeliveryDurationType'
      );
    },
    DeliveryLocationType() {
      this.deliveryLocationList = this.getEnumByTitle('DeliveryLocationType');
    },
    tradeRequestType() {
      this.tradeRequestTypeList = this.getEnumByTitle('TradeRequestType');
    },
    tradePaymentMethod() {
      this.tradePaymentMethodList = this.getEnumByTitle(
        'TradePaymentMethodType'
      );
    },
    DeliveryDurationType() {
      this.deliveryDurationTypeList = this.getEnumByTitle(
        'DeliveryDurationType'
      );
    },
    rawMaterialSupplyTypes() {
      this.rawMaterialSupplyTypesList = this.getEnumByTitle(
        'RawMaterialSupplyType'
      );
    },
    deliveryLocationItems() {
      this.deliveryLocationList = this.getEnumByTitle('DeliveryLocationType');
    },
    getDataById() {
      const loader = this.$loading.show();
      tradeRequestRepository()
        .getTradeRequestById(this.id, this.tradeBaseUrl)
        .then((res) => {
          this.tradeRequestItem = res.data;
          this.tableItems = this.tradeRequestItem.items;
          this.$store.commit('setTradeRequestSelectedForDisplay', res.data);
          this.getTradeLimitation();
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    displayResponsesPerItem(item) {
      let params = {
        tradeRequestItemId: item.id,
        pageNumber: this.pageNumber,
        itemsPerPage: this.itemsPerPage,
      };
      const loader = this.$loading.show();
      tradeRequestResponseRepository()
        .getAllResponsesPerItem(
          this.tradeBaseUrl,
          { MerchantId: this.merchantId },
          params
        )
        .then((res) => {
          this.$store.commit('setTradeRequestResponsesHeader', item);
          this.$store.commit('setTradeRequestResponsesPerItem', res.data);
          this.$router.push({ path: `/trade-request-list-per-item` });
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
  },
};
</script>

<style></style>
